import { useState, useEffect } from "react";
import validator from "validator";
import { format } from "date-fns";
import { useNavigate } from 'react-router-dom';
import { getGeneralTypes, postData, postDataResponse } from "./Services";
import { StyledSelect, InputContainer, InputWrapper, HeaderContainer, HeaderText, NoteField, GreyButton, RedButton, RightJustifyDiv, SubmitSpan, divOverflowHidden, divFloatLeft, divFloatRight, StyledSelectLeft, StyledSelectRight } from "./Style";
import { useMsal } from "@azure/msal-react";
//import { Grid, TextField, Button, Card, CardContent, CardHeader, Typography, InputLabel, MenuItem, FormControl, Select } from '@mui/material/';
import { Grid, TextField, Backdrop, Button, Card, CircularProgress, CardContent, CardHeader, Typography, InputLabel, MenuItem, FormControl, Select } from '@mui/material/';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ConfirmDialog from "./ConfirmDialog";

const RequestForRemovalForm = ({ onSave, Case = {} }) => {
    const { instance } = useMsal();
    const [userEmail, setUserEmail] = useState('');
    const [MatterID, setMatterID] = useState([]);
    const [RateData, setRateData] = useState([]);
    const [SelectedRateData, setSelectedRateData] = useState([]);
    const [selectedValueMatterID, setSelectedValueMatterID] = useState("");
    const [errorRequest, setErrorRequest] = useState(false);
    const [dialogDestUrl, setDialogDestUrl] = useState("");
    const [requestReasonVal, setRequestReason] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [dialogMessage, SetDialogMessage] = useState("");
    const [isUploading, setUploading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [selectedRequestType, setSelectedRequestType] = useState("");
    const [RequestDateVal, SetRequestDateVal] = useState(new Date());
    const [SelectedProfRate, SetSelectedProfRate] = useState("");
    useEffect(() => {

        async function fetchInitialData(_email) {
            const tokenRequest = {
                account: currentAccount, // This is an example - Select account based on your app's requirements
                scopes: ["User.Read"]
            }
            const currentAccount = instance.getActiveAccount();
            var body = {};
            if (currentAccount) {
                setUserEmail(currentAccount.username);
                body.email = currentAccount.username;
            }
            const matterIDResponse = await postDataResponse('/Invoice/GetPersonnelRates', body);  //await getMatterID(body.email);
            const matterList = matterIDResponse.data.filter((value, index, self) =>
                index === self.findIndex((t) => (
                    t.matterID === value.matterID && t.matterDescription === value.matterDescription
                ))
            ).map(obj => ({ id: obj.matterID, name: obj.matterDescription }));
            matterIDResponse.errors ? setErrorRequest(true) : setMatterID(matterList);
            const updatedRateData = matterIDResponse.data.map((row) => ({ id: uuidv4(), ...row }));

            setRateData(updatedRateData);
            setSelectedRateData(updatedRateData);
            setSelectedValueMatterID("ALL");

        }
        fetchInitialData();
    }, [instance, userEmail]);

    const uuidv4 = () => {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
            /[xy]/g,
            function (c) {
                const r = (Math.random() * 16) | 0,
                    v = c === "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            }
        );
    };

    const handleSelectChangeMatterID = (event) => {
        setSelectedValueMatterID(event.target.value);
        if (event.target.value == "") {
            setSelectedRateData([]);
        }
        if (event.target.value == "ALL") {
            setSelectedRateData(RateData);
        }
        if (event.target.value != "" && event.target.value != "ALL") {
            setSelectedRateData(RateData.filter(x => x.matterID === event.target.value));
        }
    };

    const handleSelectProfRate = (event) => {
        console.log(event.target.value);
        SetSelectedProfRate(event.target.value);
        const currentRateSelected = RateData.filter(x => x.id === event.target.value)[0];       
        console.log(RateData);
        console.log(currentRateSelected);        
    };

    const handleSelectRequestType = (event) => {
        setSelectedRequestType(event.target.value);

    };

    async function handleSubmit(e) {
        e.preventDefault();
        setUploading(true);
        const form = e.target;
        const formData = new FormData(form);

        const formJson = Object.fromEntries(formData.entries());

        
        const currentRateSelected = RateData.filter(x => x.id === SelectedProfRate)[0];
        console.log(currentRateSelected);

        let postObject = {
            EMail: userEmail,
            MatterID: currentRateSelected.matterID,
            DateOfRequest: format(RequestDateVal.$d, "MM/dd/yyyy"),
            PersonnelName: currentRateSelected.fullName,
            Type: currentRateSelected.type,
            EffectiveDate: currentRateSelected.effectiveDate,
            Rate: currentRateSelected.rate,
            Reason: requestReasonVal
        };

        postDataResponse('/Matter/RequestForPersonnelRemoval', postObject).then((response) => {
            setUploading(false);
            if (response.status === 200 || response.status === 201) {
                setIsSuccess(true);
                SetDialogMessage("Personnel Removal was Successfully Submitted");
            }
            else {
                setIsSuccess(false);
                SetDialogMessage(response.data);
            }
            setOpenDialog(true);
        });
    };
  const handleCloseDialog = () => { setOpenDialog(false); };
    return (
        <form method="post" onSubmit={handleSubmit}>
            <div>
                <Card className="form-card">
                    <CardHeader title="Request For Personnel Removal" style={{ backgroundColor: "#8B0E04", color: "#fff" }} />
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={8}>
                                <FormControl fullWidth margin="normal">
                                    <InputLabel id="MatterIDSelectLbl">Matter ID</InputLabel>
                                    <Select
                                        labelId="MatterIDSelectLbl"
                                        id="MatterIDSelect"
                                        name="MatterIDSelect"
                                        value={selectedValueMatterID}
                                        label="Matter ID"
                                        onChange={handleSelectChangeMatterID}
                                        required
                                    >
                                        <MenuItem value="ALL">All Professional Rates</MenuItem>
                                        {MatterID !== null ? MatterID.map((value) => (
                                            <MenuItem key={value.id} value={value.id}>
                                                {value.name}
                                            </MenuItem >
                                        )) : <MenuItem ></MenuItem >}

                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid xs={12} sm={4} item>
                                <FormControl fullWidth margin="normal">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker label="Date of Request" name="RequestDate" id="RequestDate" onChange={(newValue) => { SetRequestDateVal(newValue); setIsValid(true); }} value={dayjs('RequestDateVal')} defaultValue={new Date()} />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid xs={12} item>
                                <FormControl fullWidth margin="normal">
                                    <InputLabel id="ProfessionalSelectLbl">Professional Rate</InputLabel>
                                    <Select
                                        labelId="ProfessionalSelectLbl"
                                        id="ProfessionalSelect"
                                        name="ProfessionalSelect"
                                        value={SelectedProfRate}
                                        label="Matter ID"
                                        onChange={handleSelectProfRate}
                                        required
                                    >

                                        {SelectedRateData !== null ? SelectedRateData.map((value) => (
                                            <MenuItem key={value.id} value={value.id}>
                                                {value.matterID + " - " + value.fullName + " - " + value.type + " - " + value.effectiveDate + " - " + value.rate}
                                            </MenuItem >
                                        )) : <MenuItem ></MenuItem >}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid xs={12} item>
                                <TextField
                                    name="txtRequestReason"
                                    label="Reason for Request" variant="outlined" margin="normal"
                                    multiline
                                    rows={5}
                                    maxRows={15}
                                    value={requestReasonVal}
                                    onChange={e => setRequestReason(e.target.value)}
                                    required
                                    fullWidth
                                    placeholder="Reason for Request"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Button type="submit" variant="contained" style={{ backgroundColor: "rgb(207, 66, 64)" }} fullWidth>Submit</Button>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Button type="reset" variant="contained" style={{ backgroundColor: "rgb(51, 51, 51)" }} value="Reset" fullWidth>Clear</Button>
                            </Grid>
                        </Grid>


                    </CardContent>
                </Card>
                <Backdrop
                    sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                    open={isUploading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
            <ConfirmDialog 
          isOpen={openDialog}
          onClose={handleCloseDialog}
          isSuccess={isSuccess}
          message = {dialogMessage}
          destination={dialogDestUrl}
        />
        </form>
    );
};
export default RequestForRemovalForm;